import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Publication } from 'src/app/models/obs/publication';
import { PublicationService } from 'src/app/services/obs/publication.service';

@Component({
  selector: 'app-admpublications-form-youtube',
  templateUrl: './admpublications-form-youtube.component.html',
  styleUrl: './admpublications-form-youtube.component.scss'
})
export class AdmpublicationsFormYoutubeComponent implements OnInit {

  form: FormGroup;
  publication: Publication = null;
  edit: boolean = false;

  constructor(
    private publicactionS: PublicationService,
    private fb: FormBuilder,
    private router: Router,
    private activedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.createForm();
    this.getOnePublication();
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      urls: ['', Validators.required]
    })
  }

  getOnePublication() {
    const id = this.activedRoute.snapshot.params['id'];
    this.publicactionS.getOne(id).subscribe({
      next: res => {
        this.publication = res["data"];
        this.loadData();
        this.edit = true;
      },
      error: err => {
        console.log(err);
      }
    })
  }

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }
  
  update(id: string, publication: Publication) {
    delete publication.id;
    this.splitUrls(publication);
    this.publicactionS.update(id, publication).subscribe({
      next: res => { console.log("res update: ", res) },
      error: err => { console.error(err) }
    });
  }

  create(publication: Publication) {
    delete publication.id;
    this.splitUrls(publication);
    this.publicactionS.create(publication).subscribe({
      next: res => { console.log("res create: ", res) },
      error: err => { console.error(err) }
    });
  }

  splitUrls(publication: Publication) {
    const urlsValue = this.form.get('urls').value;
    if (typeof urlsValue === 'string') {
      publication.urls = urlsValue.split('\n');
    }
  }

  save() {
    if (this.form.invalid) {
      return Object.values(this.form.controls).forEach(control => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach(control => control.markAsTouched());
        } else {
          control.markAsTouched();
        }
      });
    } else {
      this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
      this.router.navigate(['adm/publicacion/list/']);
    }
  }

  loadData() {
    this.form.reset(this.publication);
  }
  cancel() {
    this.router.navigate(['adm/publicacion/list/']);
  }

  //Inicio validar formato yotuube/embed

  getFormattedUrls(): string {
    const urls = this.form.get('urls').value;
    return Array.isArray(urls) ? urls.join('\n') : urls;
  }

  onUrlInputChange() {
    const urls = this.form.get('urls').value;
    if (typeof urls === 'string') {
      const urlsArray = urls.split('\n');
      const invalidUrls = urlsArray.filter(url => !this.isYouTubeEmbedUrl(url));

      if (invalidUrls.length > 0) {
        this.showErrorMessage("Algunas URLs no son del tipo embed de YouTube. Debes utilizar URLs de tipo embed.");
      } else {
        this.hideErrorMessage();
      }
    }
  }

  isYouTubeEmbedUrl(url: string): boolean {
    return url.includes('youtube.com/embed');
  }

  errorMessage: string | null = null;
  showErrorMessage(message: string) {
    this.errorMessage = message;
  }

  hideErrorMessage() {
    this.errorMessage = null;
  }

  //Fin validar formato yotuube/embed
}

